import { z } from 'zod';

/**
 * Which side of the marketplace an organization sits on. Stored as a Postgres
 * enum, so the string values are load-bearing — see the `organizations.type`
 * column and every RLS policy that predicates on it.
 */
export const ORGANIZATION_TYPES = ['purchaser', 'supplier'] as const;

export type OrganizationType = (typeof ORGANIZATION_TYPES)[number];

export const organizationTypeSchema = z.enum(ORGANIZATION_TYPES);
